<template>
  <div class="surround">
    <div class="box">
      <form @submit.prevent="submit">
        <input
          :class="['input', { 'underError': error }]"
          type="text"
          placeholder="přihlašovací jméno"
          v-model="username">
        <input
          :class="['input', { 'underError': error }]"
          type="password"
          placeholder="heslo"
          v-model="password">
        <button class="btn centered isBlue" @click.prevent="submit">
          <icon type="log-in" size="16" />
          Přihlásit se
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import mAccount from '../mixins/account';
import { postLogin } from '../http';

export default {
  mixins: [mAccount],

  data() {
    return {
      username: '',
      password: '',
      error: null
    };
  },

  methods: {
    async submit() {
      try {
        const { data: { data: { token } } } = await postLogin(this.username, this.password);

        if (token) {
          this.$store.commit('login', token);
          this.redirect();
        }
      } catch (error) {
        this.error = 'Wrong password or username';
      }
    }
  }
};
</script>

<style lang="sass" scoped>
@import '../styles/surround.sass'
@import '../styles/login.sass'
@import '../styles/buttons.sass'
</style>
